<template>
  <div>
    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="$t('newSubject')">
      <header-button icon="mdi-close"
                     slot="left-button"
                     v-bind:label="$t('cancel')"
                     v-bind:to="{ name: 'learning-subjects' }" />
      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="createSubject" />
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container>
      <v-row>
        <v-col cols="12"
               lg="6">
          <subject-details-card ref="subjectDetailsCard"
                                v-bind:subject="subject" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import SubjectDetailsCard from '@/components/learning/SubjectDetailsCard.vue'

  export default {
    components: {
      HeaderButton,
      SubjectDetailsCard,
      TopHeader
    },
    data: () => ({
      loading: false,
      subject: {},
      validationSnackbar: false
    }),
    methods: {
      async createSubject() {
        if (!this.$refs.subjectDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        await this.doCreateSubject({ subject: this.subject })

        this.$router.push({ name: 'learning-subjects' })
      },
      ...mapActions({
        doCreateSubject: 'learning/createSubject'
      })
    },
    name: 'SubjectAdd'
  }
</script>

<i18n>
  {
    "de": {
      "cancel": "Abbrechen",
      "newSubject": "Neues Modul",
      "save": "Speichern",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "cancel": "Cancel",
      "newSubject": "New subject",
      "save": "Save",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>